import { useEffect, useState, useRef } from "react"
import * as tf from "@tensorflow/tfjs"
import { MOBILENET_URL } from "../constants/modelConstants"

export default function useMobilenetLoader() {
  const [mobilenet, setMobilenet] = useState(null)
  // Guard against setting state after unmount: the MobileNet load can take many
  // seconds, and the user may navigate away before it resolves.
  const mountedRef = useRef(true)

  useEffect(() => {
    mountedRef.current = true
    loadModel()
    return () => {
      mountedRef.current = false
    }
  }, [])

  const loadModel = async () => {
    try {
      const model = await tf.loadGraphModel(MOBILENET_URL, {
        fromTFHub: true,
      })

      if (!mountedRef.current) return
      setMobilenet(model)
      console.log("Model loaded")
    } catch (e) {
      console.error("ERROR", e)
    }
  }

  return mobilenet
}
